import React from "react";

const RhKpiCard = ({ label, value, unit, variant = "primary", sub }) => (
  <div className={`rh-kpi-card rh-kpi-${variant}`}>
    <div className="rh-kpi-label">{label}</div>
    <div className="rh-kpi-value">
      {value}
      {unit && <span className="rh-kpi-unit">{unit}</span>}
    </div>
    {sub && <div className="rh-kpi-sub">{sub}</div>}
  </div>
);

export default RhKpiCard;
